"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=i18nTypes.js.map